import { render, staticRenderFns } from "./carts.vue?vue&type=template&id=a978b244&scoped=true"
import script from "./carts.vue?vue&type=script&lang=js"
export * from "./carts.vue?vue&type=script&lang=js"
import style0 from "./carts.vue?vue&type=style&index=0&id=a978b244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a978b244",
  null
  
)

export default component.exports